import { gql } from "@apollo/client";

export const FETCH_SUPPLIER_STOCK_OVERVIEW = gql`
  query FETCH_SUPPLIER_STOCK_OVERVIEW($supplierId: ID!) {
    supplierStockOverview(supplierId: $supplierId)
  }
`;

export const FETCH_SUPPLIER_STOCK_PRODUCTS = gql`
  query FETCH_SUPPLIER_STOCK_PRODUCTS {
    supplierStockProducts {
      id
      odooId
      name
      nameCn
      number
      supplierStockPlanningQty
    }
  }
`;

export const FETCH_PRODUCT_STOCK_DETAIL = gql`
  query FETCH_PRODUCT_STOCK_DETAIL($id: ID!) {
    product(id: $id) {
      id
      odooId
      number
      name
      nameCn
    }
    supplierStock(productId: $id)
  }
`;

export const CREATE_SUPPLIER_STOCK_UPDATE_REQUEST = gql`
  mutation CREATE_SUPPLIER_STOCK_UPDATE_REQUEST(
    $supplierId: ID!
    $data: String!
  ) {
    createSupplierStockUpdateRequest(supplierId: $supplierId, data: $data) {
      supplierStockUpdateRequest {
        id
        state
      }
    }
  }
`;
